import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, Tooltip } from '@material-ui/core';
import ShowChartIcon from '@material-ui/icons/ShowChart';

import { IMilestoneEvaluation } from '../../../lib/helpers/player-milestone.helpers';
import { PLAYER_MILESTONE_TYPE_LABELS } from '../../../lib/types';
import { MilestoneEvolutionChart } from './milestone-evolution-chart.component';

interface IMilestoneChartButtonProps {
  type: PlayerMilestoneType;
  evaluation?: IMilestoneEvaluation;
}

// Icon button opening the over-time evolution chart for one measurement, disabled
// until a reading exists. Shared by the display row and the editable field so the
// chart-dialog wiring lives in one place.
export const MilestoneChartButton: React.FC<IMilestoneChartButtonProps> = ({ type, evaluation }) => {
  const [open, setOpen] = useState(false);
  const label = PLAYER_MILESTONE_TYPE_LABELS[type];
  const hasEntries = !!evaluation?.entries.length;

  return (
    <>
      <Tooltip title={`View ${label.toLowerCase()} over time`}>
        <span>
          <IconButton size="small" disabled={!hasEntries} onClick={() => setOpen(true)} aria-label={`View ${label} over time`}>
            <ShowChartIcon />
          </IconButton>
        </span>
      </Tooltip>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{label} over time</DialogTitle>
        <DialogContent>
          <MilestoneEvolutionChart type={type} entries={evaluation?.entries || []} />
        </DialogContent>
      </Dialog>
    </>
  );
};
